package pl.decks.chartjs.radar.dataset

import pl.decks.chartjs.external.JsObject
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.value.ClipValue

data class RadarDataSet(
    val label: String,
    val data: List<Number>,
    val order: Int = 0,
    val clip: ClipValue? = null,
    val line: LineProperties,
    val point: PointProperties,
    val lineHover: LineHoverProperties? = null,
    val pointHover: PointHoverProperties? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.label = label.asDynamic()
        this.data = data.toTypedArray().asDynamic()
        this.order = order.asDynamic()
        if (clip != null) this.clip = clip.toChartJs()

        JsObject.assign(this, line.toChartJs())

        JsObject.assign(this, point.toChartJs())


        if (lineHover != null) {
            JsObject.assign(this, lineHover.toChartJs())
        }
        if (pointHover != null) {
            JsObject.assign(this, pointHover.toChartJs())
        }
    }
}
